module.exports = __webpack_public_path__ + "static/img/kus3.b58857a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kus3.gif
// module id = 8NLs
// module chunks = 1